import { RichEditor } from '@odo/shared-ui';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { parseRichText } from '../utils/richText';

interface RichTextBodyProps {
    /** The stored column value: a Tiptap document as JSON, or legacy text. */
    value: string | null | undefined;
    /**
     * How to render a value that is not a document. `markdown` matches how FAQ
     * answers have always rendered; `plain` matches the video description, which
     * was never parsed as markdown and must not start being now - an author who
     * typed an asterisk meant an asterisk.
     */
    fallback: 'markdown' | 'plain';
    className?: string;
}

/**
 * Read-only view of a rich-text field. The editor renders its own document in
 * `readOnly`/`bare` mode, which is what keeps authoring and reading in one
 * format instead of two renderers drifting apart.
 */
export const RichTextBody: React.FC<RichTextBodyProps> = ({ value, fallback, className }) => {
    const doc = parseRichText(value);

    if (doc) {
        return (
            <div className={className}>
                <RichEditor
                    value={doc}
                    onChange={() => undefined}
                    readOnly
                    chrome="bare"
                    allowImages={false}
                />
            </div>
        );
    }

    if (fallback === 'markdown') {
        return (
            <div className={className}>
                <ReactMarkdown>{value ?? ''}</ReactMarkdown>
            </div>
        );
    }

    // Verbatim, exactly as this field rendered before the editor existed.
    return <p className={className}>{value ?? ''}</p>;
};

export default RichTextBody;
